export default "__VITE_ASSET__91292eee__"